export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8594.9f47ab36.jpg";